module.exports = __webpack_public_path__ + "img/bg.22ba6b82.png";